module.exports = __webpack_public_path__ + "static/media/2004.df7c4ec1.svg";